"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoCodeRequestBaseToJSON = exports.PromoCodeRequestBaseFromJSONTyped = exports.PromoCodeRequestBaseFromJSON = exports.instanceOfPromoCodeRequestBase = void 0;
/**
 * Check if a given object implements the PromoCodeRequestBase interface.
 */
function instanceOfPromoCodeRequestBase(value) {
    var isInstance = true;
    isInstance = isInstance && "promoCodeId" in value;
    isInstance = isInstance && "campaignBudgetMicro" in value;
    isInstance = isInstance && "accountId" in value;
    isInstance = isInstance && "accountCountry" in value;
    return isInstance;
}
exports.instanceOfPromoCodeRequestBase = instanceOfPromoCodeRequestBase;
function PromoCodeRequestBaseFromJSON(json) {
    return PromoCodeRequestBaseFromJSONTyped(json, false);
}
exports.PromoCodeRequestBaseFromJSON = PromoCodeRequestBaseFromJSON;
function PromoCodeRequestBaseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'promoCodeId': json['promo_code_id'],
        'campaignBudgetMicro': json['campaign_budget_micro'],
        'accountId': json['account_id'],
        'accountCountry': json['account_country'],
    };
}
exports.PromoCodeRequestBaseFromJSONTyped = PromoCodeRequestBaseFromJSONTyped;
function PromoCodeRequestBaseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'promo_code_id': value.promoCodeId,
        'campaign_budget_micro': value.campaignBudgetMicro,
        'account_id': value.accountId,
        'account_country': value.accountCountry,
    };
}
exports.PromoCodeRequestBaseToJSON = PromoCodeRequestBaseToJSON;
